import { createFileRoute } from '@tanstack/react-router';

import { PenViewerRoute } from './-penViewer/PenViewerRoute.tsx';

export const Route = createFileRoute('/(app)/penViewer')({
  component: PenViewerRoute,
});
